/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityPostureTenantResponse {
    getFixupPrototypeFunction() { return SecurityPostureTenantResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityPostureTenantResponse>): SecurityPostureTenantResponse {
        let obj = Object.assign(new SecurityPostureTenantResponse(), model);
        SecurityPostureTenantResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityPostureTenantResponse>): SecurityPostureTenantResponse {
        if (!model) return null;
        return SecurityPostureTenantResponse.newInstance(<SecurityPostureTenantResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityPostureTenantResponse) {
        if (!obj) return;

        models.SecurityPostureTenantResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityPostureTenantResponse): boolean {
        Object.setPrototypeOf(obj, SecurityPostureTenantResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
    }

    /**
     * Total number of page count
     */
    page_count: number;

    /**
     * Tenant wise count details
     */
    tenants: any;

    /**
     * Number of Tenants
     */
    total_count: number;

}
